import { signOut as nextAuthSignOut } from 'next-auth/react'

import { useCookieUserInfo } from './userCookie'

import { useSiteSpecificContext } from '@/contexts/SiteSpecificContext'
import { ALL_DRAFT_STORAGE_KEYS } from '@/pages/tad.ai/_shared/formDraft/draftKeys'


import { useRouter } from '@/hooks/routes';
import { useCallback } from 'react';
export function useSignOut() {
  const router = useRouter()
  const { removeCookieUserInfo } = useCookieUserInfo()
  const { clearSiteSpecificContext } = useSiteSpecificContext()
  const signOut = useCallback(
    async (options?: { redirect?: string }) => {
      const { redirect = '/' } = options || {}

      await nextAuthSignOut({ redirect: false })
      ALL_DRAFT_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key))
      clearSiteSpecificContext()
      removeCookieUserInfo()
      router.push(redirect)
    },
    [clearSiteSpecificContext, removeCookieUserInfo, router],
  )
  return signOut
}
